import React from 'react'
import { useEditorStore } from '../store.js'

export function SnapshotHistory() {
  const {
    currentProject,
    restoreSnapshot,
    undo,
    redo,
    canUndo,
    canRedo
  } = useEditorStore()

  const snapshots = currentProject?.snapshots ?? []
  const currentSnapshotIndex = currentProject?.currentSnapshotIndex ?? -1

  const formatTimestamp = (timestamp: number) => {
    const date = new Date(timestamp)
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })
  }

  if (snapshots.length === 0) {
    return (
      <div className="snapshot-history">
        <div className="snapshot-history__header">
          <h3 className="snapshot-history__title">History</h3>
        </div>
        <div className="snapshot-history__empty">
          <p>No snapshots yet.</p>
          <p className="snapshot-history__hint">Snapshots are created automatically when the AI modifies your wireframe.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="snapshot-history">
      <div className="snapshot-history__header">
        <h3 className="snapshot-history__title">History</h3>
        <div className="snapshot-history__controls">
          <button
            type="button"
            className="snapshot-history__control-button"
            onClick={undo}
            disabled={!canUndo()}
            title="Undo (Ctrl+Z)"
          >
            ↶ Undo
          </button>
          <button
            type="button"
            className="snapshot-history__control-button"
            onClick={redo}
            disabled={!canRedo()}
            title="Redo (Ctrl+Shift+Z)"
          >
            ↷ Redo
          </button>
        </div>
      </div>
      <div className="snapshot-history__list">
        {snapshots.map((snapshot, index) => (
          <div
            key={snapshot.id}
            className={`snapshot-history__item ${
              index === currentSnapshotIndex ? 'snapshot-history__item--active' : ''
            }`}
            onClick={() => restoreSnapshot(snapshot.id)}
          >
            <div className="snapshot-history__item-header">
              <span className="snapshot-history__item-time">{formatTimestamp(snapshot.timestamp)}</span>
              {index === currentSnapshotIndex && (
                <span className="snapshot-history__item-badge">Current</span>
              )}
            </div>
            {snapshot.userPrompt && (
              <div className="snapshot-history__item-prompt">
                <strong>Prompt:</strong> {snapshot.userPrompt}
              </div>
            )}
            {snapshot.aiSummary && (
              <div className="snapshot-history__item-summary">
                <strong>Changes:</strong> {snapshot.aiSummary}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
